import styled, { css } from 'styled-components';

import { CallPriorityEnum } from '~/enums/CallPriorityEnum';

interface IContainerProps {
  readonly priority: CallPriorityEnum;
}

export const Container = styled.li<IContainerProps>`
  width: 220px;
  height: 220px;
  border-radius: ${({ theme }) => theme.borderRadius.md};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: 0.25s;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 28px,
    rgba(0, 0, 0, 0.22) 0px 10px 10px;

  ${({ priority }) =>
    priority === CallPriorityEnum.neutral
      ? css`
          background-color: ${({ theme }) => theme.colors.background};
          background-image: linear-gradient(
            to bottom,
            ${({ theme }) => theme.colors.background},
            rgba(20, 20, 20, 0.5)
          );
        `
      : priority === CallPriorityEnum.low
      ? css`
          background-color: ${({ theme }) => theme.colors.lowPriority};
          background-image: linear-gradient(
            to bottom,
            ${({ theme }) => theme.colors.lowPriority},
            rgba(20, 20, 20, 0.5)
          );
        `
      : priority === CallPriorityEnum.hight
      ? css`
          background-color: ${({ theme }) => theme.colors.hightPriority};
          background-image: linear-gradient(
            to bottom,
            ${({ theme }) => theme.colors.hightPriority},
            rgba(20, 20, 20, 0.5)
          );
        `
      : priority === CallPriorityEnum.veryHight &&
        css`
          background-color: ${({ theme }) => theme.colors.veryHightPriority};
          background-image: linear-gradient(
            to bottom,
            ${({ theme }) => theme.colors.veryHightPriority},
            rgba(20, 20, 20, 0.5)
          );
        `}

  > span {
    font-size: 70px;
    font-weight: bold;
    color: ${({ theme }) => theme.colors.cardText};
  }

  > small {
    font-size: 30px;
    color: ${({ theme }) => theme.colors.cardText};
  }
`;
